import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import {
  AddImages,
  ImageCrop
} from '../../components';
import css from './EditListingPhotosForm.module.css';
import { replaceFileName } from './utils';

const ACCEPT_IMAGES = 'image/*';

export class PortfolioPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCrop: false,
    };
  }

  handleShowCrop = (e, key) => {
    e.preventDefault();
    this.setState({ showCrop: true }, () => this.setState({ showCrop: false }))
  }

  render() {

    const {
      isMobSaf,
      form,
      publicData,
      images,
      intl,
      imageUploadRequested,
      onImageUploadHandler,
      onRemoveImage,
      handleSubmitFile,
      handleCloseCropPopup,
    } = this.props

    const { showCrop } = this.state;

    const imagesConfig = {
      label: 'Portfolio Photos',
      key: 'portfolioPhoto',
      placeholder: '+ Add Portfolio Photos',
      countLimit: 20,
      photoIdKey: 'portfolioPhotoIds',
    };

    const label = imagesConfig.label;
    const tip = imagesConfig.tip;
    const key = imagesConfig.key;
    const placeholder = imagesConfig.placeholder;
    const countLimit = imagesConfig.countLimit;

    const firstImageId = publicData?.backgroundPhotoIds;

    const firstImagePresents = !!images.filter(img => img?.id?.uuid === firstImageId)?.length
    const newFirstImagePresents = !!images.filter(img => typeof img.id === 'string' && img.id?.includes('backgroundPhoto-'))?.length;

    const imagesArray = !firstImagePresents && !newFirstImagePresents ? images : images?.slice(1);
    const showAddImageField = imagesArray?.length < countLimit;

    return (
      <>
        <p className={css.fieldLabel}>{label}</p>
        <p className={css.fieldLabelTip}>{tip}</p>
        <AddImages
          className={css.imagesField}
          images={imagesArray}
          thumbnailClassName={css.thumbnail}
          savedImageAltText={intl.formatMessage({
            id: 'EditListingPhotosForm.savedImageAltText',
          })}
          onRemoveImage={onRemoveImage}
          imageKey={key}
        >
          {showAddImageField && (
            <Field
              id={key}
              name={key}
              accept={ACCEPT_IMAGES}
              form={null}
              label={placeholder}
              type="file"
              disabled={imageUploadRequested}
            >
              {fieldprops => {
                const { accept, input, label, disabled: fieldDisabled } = fieldprops;
                const { name, type, index } = input;
                const onChange = e => {
                  const file = e.target.files[0];
                  const newFile = replaceFileName(file, key);

                  form.change(key, newFile);
                  form.blur(key);

                  onImageUploadHandler(newFile);
                };
                const inputProps = { accept, id: name, name, onChange, type };

                // const inputProps = {
                //   id: name,
                //   name,
                //   type,
                //   accept,
                //   ...(isMobSaf ? {
                //     onChange: e => {
                //       // const file = e.target.files[0];
                //       // form.change(`addImage`, file);
                //       // form.blur(`addImage`);
                //       // onImageUploadHandler(file);
                //       const file = e.target.files[0];
                //       const newFile = replaceFileName(file, key);

                //       form.change(key, newFile);
                //       form.blur(key);

                //       onImageUploadHandler(newFile);
                //     }
                //   } : {
                //     onClick: e => this.handleShowCrop(e, key)
                //   })
                // };

                return (
                  <div className={css.addImageWrapper}>
                    <div className={css.aspectRatioWrapper}>
                      {fieldDisabled ? null : (
                        <input {...inputProps} className={css.addImageInput} />
                      )}
                      <label
                        htmlFor={name}
                        className={css.addImage}
                      >
                        {label}
                      </label>
                    </div>
                  </div>
                );
              }}
            </Field>
          )}

          <Field
            component={props => {
              const { input, meta } = props;
              return (
                <div className={css.imageRequiredWrapper}>
                  <input {...input} />
                </div>
              );
            }}
            name="images"
            type="hidden"
          />
        </AddImages>


        <ImageCrop
          key="ImageCrop.portfolioPhoto"
          isOpen={showCrop}
          submitFile={file => handleSubmitFile(file, "portfolioPhoto")}
          onClose={handleCloseCropPopup}
          aspect={48/13}
          minWidth={200}
          minHeight={55}
        />
      </>
    );
  }
}

PortfolioPhoto.defaultProps = { fetchErrors: null, images: [] };

PortfolioPhoto.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape,
  onImageUpload: func,
  onUpdateImageOrder: func,
  onSubmit: func,
  saveActionMsg: string,
  disabled: bool,
  ready: bool,
  updated: bool,
  updateInProgress: bool,
  onRemoveImage: func,
};

export default compose(injectIntl)(PortfolioPhoto);
